import React from 'react'
import PropTypes from 'prop-types'

import { RedeemMailOfferButton, AppButton } from '..'
import { Email } from '../../icons'

/*
CLASSNAME ARR STRUCTURE

[button-box, button]

*/

function ButtonGroup({
  classNameArr,
  linkArr,
  secondaryTxt,
  secondary,
  dataEventArr,
  productType,
  pageCategory,
  extraApplyParams,
  external, // TODO: remove this prop once pl-landing is working
  affiliate
}) {
  return (
    <div className={classNameArr[0]}>
      <AppButton
        className={`${classNameArr[1]} button`}
        dataEvent={dataEventArr[0]}
        productType={productType}
        pageCategory={pageCategory}
        landingKeyword={extraApplyParams ? extraApplyParams.landing_keyword : null}
        extraApplyParams={extraApplyParams}
      >
        {secondaryTxt || 'Check Your Loan Options'}
      </AppButton>

      {!secondary && !external && !affiliate && (
        <RedeemMailOfferButton
          className={`${classNameArr[1]} button--secondary`}
          href={linkArr[1]}
          dataEvent={dataEventArr[1]}
          productType={`${productType}_redeem`}
          pageCategory={pageCategory}
        >
          <Email className="button-group__icon" />
          Redeem Your Mail Offer
        </RedeemMailOfferButton>
      )}

      {/* TODO: remove this prop once pl-landing is working */}
      {external && !affiliate && (
        <RedeemMailOfferButton
          className={`${classNameArr[1]} button--secondary`}
          href={linkArr[1]}
          dataEvent={dataEventArr[1]}
          productType={`${productType}_redeem`}
          pageCategory={pageCategory}
        >
          <Email className="button-group__icon" />
          Redeem Your Mail Offer
        </RedeemMailOfferButton>
      )}
    </div>
  )
}

ButtonGroup.defaultProps = {
  linkArr: ['', ''],
  secondaryTxt: null,
  secondary: false,
  external: false,
  affiliate: false
}

ButtonGroup.propTypes = {
  classNameArr: PropTypes.array.isRequired,
  pageCategory: PropTypes.string.isRequired,
  secondaryTxt: PropTypes.string,
  secondary: PropTypes.bool,
  dataEventArr: PropTypes.array.isRequired,
  external: PropTypes.bool, // TODO: remove this prop once pl-landing is working
  linkArr: PropTypes.array,
  /* eslint-disable react/require-default-props */
  productType: PropTypes.string,
  extraApplyParams: PropTypes.object,
  /* eslint-enable react/require-default-props */
  affiliate: PropTypes.bool
}

export default ButtonGroup
